import { PropsWithChildren, useMemo } from 'react';

import { XYChartDownloadContext } from '../context/XYChartDownload.context.js';
import type { XYChartDownloadContextValue } from '../context/XYChartDownload.context.js';

type XYChartDownloadProviderProps =
  PropsWithChildren<XYChartDownloadContextValue>;

export const XYChartDownloadProvider = ({
  children,
  downloadDataCallback,
}: XYChartDownloadProviderProps) => {
  const value = useMemo(
    () => ({ downloadDataCallback }),
    [downloadDataCallback],
  );

  return (
    <XYChartDownloadContext.Provider value={value}>
      {children}
    </XYChartDownloadContext.Provider>
  );
};
